import React from 'react';
import PropTypes from 'prop-types';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';

const BreadcrumbsContent = ({ t, }) => {
  return (
    <div className="main-area__header">
      <div className="row">
        <div className="details__menu">
          <ul>
            {t('content')}
          </ul>
        </div>
      </div>
    </div>
  );
};

BreadcrumbsContent.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withScopedTranslations('breadcrumbs')(BreadcrumbsContent);
